import React from 'react';

function SelectMes(props){
    return(props.meses.map(mes => <option key={mes.id} value={mes.id}>{mes.nombre}</option>))
}

export default SelectMes;